import React from 'react';
import PropTypes from 'prop-types';

const Select = ({ className, value, setValue, tabsDataArray }) => {
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <div className="flex justify-center">
      <select
        className={`m-4 p-2 w-56  text-xl outline-none border-1 border-solid border-gray-300 rounded shadow focus:border-primary-dark ${
          className || ''
        }`}
        value={value}
        onChange={handleChange}
      >
        {tabsDataArray.map(([listKey], index) => (
          <option key={index} value={`${index}`}>
            {listKey}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;

Select.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  setValue: PropTypes.func,
  tabsDataArray: PropTypes.array,
};

// import React, { useState } from 'react';

// const Select = () => {
//   const [category, setCategory] = useState('php');

//   const handleChange = (event) => {
//     setCategory(event.target.value);
//     console.log(event.target.value);
//   };

//   return (
//     <select
//       className="m-20 p-2 w-56 text-xl border-2 border-solid border-gray-300 rounded-lg shadow-lg focus:border-primary-dark"
//       value={category}
//       onChange={handleChange}
//     >
//       <option value="php">PHP</option>
//       <option value="laravel">Laravel</option>
//       <option value="angular">Angular</option>
//       <option value="react">React</option>
//       <option value="vue">Vue</option>
//     </select>
//   );
// };

// export default Select;
